import { Icon, Label } from '@busybusy/webapp-react-ui';
import { InfoIcon, PhotoIcon } from 'assets/icons';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import { t } from 'utils/localize';
import './ProcessingPhoto.scss';
import TooltipIcon from 'components/foundation/TooltipIcon/TooltipIcon';

export interface IProcessingPhotoProps {
  className?: ClassName;
}

const ProcessingPhoto = (props: IProcessingPhotoProps) => {
  const { className } = props;

  const classes = classNames('processing-photo', className);

  return (
    <div className={classes}>
      <Icon svg={PhotoIcon} size={50} className="processing-photo-icon" />
      <Label className={'title-label'}>{t('Waiting to Sync')}</Label>
      <TooltipIcon
        className="processing-photo-icon"
        svg={InfoIcon}
        tooltipLabel={t('Images will sync once the employee has a stable internet connection.')}
      />
    </div>
  );
};

export default ProcessingPhoto;
